export default {
  metadata: {
    version: '1.0.0',
    id: 'fab-1.0.0',
    name: 'JDSFAB',
    description:
      'The Floating Action Button(FAB) performs the primary, or most common, action on a screen.',
    usage:
      'It places the key user action within easy reach by being persistently visible at a fixed point on a screen.'
  },
  hierarchy: {
    popup: [
      {
        'popup-container': ['jds_fab_internal']
      }
    ]
  },
  base: {
    popup: {
      priority: 50,
      passive: true
    },
    'popup-container': {
      show: true,
      'flex-direction': '{f_0}',
      'justify-content': '{f_1}',
      'align-items': '{f_2}',
      size: '{f_3}',
      'padding-right': '{f_4}',
      'padding-bottom': '{f_5}',
      transition: {
        property: ['padding-bottom'],
        duration: '{rapid}',
        'timing-function': '{easeJoyfulEntrance}'
      }
    },
    jds_fab_internal: {
      hidden: false
    }
  },
  variant: {
    show: {
      false: {
        'popup-container': {
          'padding-bottom': '0'
        },
        jds_fab_internal: {
          show: false
        }
      }
    },
    extend: {
      false: {
        jds_fab_internal: {
          extend: false
        }
      }
    }
  },
  combination: [{}],
  combination_config: [],
  api: {
    data: {
      jds_fab_internal: {
        title: {
          type: 'string',
          name: 'title',
          doc_description: 'It displays the title of FAB.'
        },
        icon: {
          type: 'icon',
          name: 'icon',
          doc_description: 'It displays icon of FAB.'
        }
      }
    },
    config: {
      show: {
        values: [true, false],
        doc_description: 'It can be used to show or hide FAB.'
      },
      extend: {
        values: [true, false],
        doc_description: 'When false, shows only icon.'
      }
    },
    events: {
      jds_fab_internal: {
        onClick: 'onClick',
        onHover: {
          name: 'onHover',
          platform: 'web'
        },
        onHoverEnd: {
          name: 'onHoverEnd',
          platform: 'web'
        }
      }
    },
    a11y: {
      jds_fab_internal: {
        properties: {
          ariaLabel: 'ariaLabel',
          ariaDescribedby: {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
